<script>
import { orderTypes } from "@/store/types/types.js";
export default {
  name: "EditOrderModal",
  props: {
    list: {
      required: true,
      type: Array
    },
    prepayList: {
      type: Array
    },
    orderId: {
      type: Number
    }
  },
  data() {
    return {
      order: {}
    };
  },
  methods: {
    checkPrepayNum() {
      if (!this.order.is_prepay) return;
      let restPrepayOrders = [...this.prepayList];
      switch (this.order.description) {
        case "2～3人":
          restPrepayOrders[1] = restPrepayOrders[1] - 1;
          break;
        case "2～3人優惠":
          restPrepayOrders[3] = restPrepayOrders[3] - 1;
          break;
        case "2～3人優惠（月）":
          restPrepayOrders[5] = restPrepayOrders[5] - 1;
          break;
        case "3～4人":
          restPrepayOrders[0] = restPrepayOrders[0] - 1;
          break;
        case "3～4人優惠":
          restPrepayOrders[2] = restPrepayOrders[2] - 1;
          break;
        case "3～4人優惠（月）":
          restPrepayOrders[4] = restPrepayOrders[4] - 1;
          break;
        case "自訂":
          restPrepayOrders[6] = 1;
          break;
        default:
          break;
      }
      restPrepayOrders.forEach(item => {
        if (item < 0) {
          alert("超過預付款項，請重新輸入！");
          this.order.description = "";
        }
      });
    },
    convertToPrice(item) {
      switch (item.description) {
        case "2～3人":
          item.price = 450;
          break;
        case "2～3人優惠":
          item.price = 405;
          break;
        case "2～3人優惠（月）":
          item.price = 380;
          break;
        case "3～4人":
          item.price = 550;
          break;
        case "3～4人優惠":
          item.price = 495;
          break;
        case "3～4人優惠（月）":
          item.price = 460;
          break;
        case "自訂":
          item.price = 0;
          break;
        default:
          item.price = 0;
          break;
      }
      return item;
    },
    editOrder(id) {
      this.convertToPrice(this.order);
      let data = {
        description: this.order.description,
        price: this.order.price,
        rice: this.order.rice,
        customized_label: this.order.customized_label,
        customized_price: this.order.customized_price,
        id: id
      };

      this.$store.dispatch(orderTypes.actions.EDIT_ORDER, data).then(() => {
        //重整列表
        this.$emit("updateList", data);
      });
    },
    closeModal() {
      this.$jquery("#editOrderModal").modal("hide");
    }
  },
  watch: {
    orderId(val) {
      this.orderId = val;
      this.order = this.list.filter(order => order.id === val)[0];
    }
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss"  />
